import { t } from '@lingui/core/macro';

/** Short due-date wording for the editor's "Due day" column (the inherited-schedules panel uses `dueOnLabel`). */
export function dueDayLabel(dueOn?: string): string {
  switch (dueOn) {
    case 'day-5':
      return t`5th of the month`;
    case 'day-10':
      return t`10th of the month`;
    case 'day-15':
      return t`15th of the month`;
    case 'end-of-month':
      return t`Last day of the month`;
    case 'following-friday':
      return t`Following Friday`;
    default:
      return dueOn ?? '';
  }
}

export function yearTypeShortLabel(yearType?: string): string {
  switch (yearType) {
    case 'CY':
      return t`Calendar`;
    case 'FY':
      return t`Fiscal`;
    default:
      return yearType ?? '';
  }
}
